import { render, staticRenderFns } from "./payment-form-v2.vue?vue&type=template&id=452467e4&"
import script from "./payment-form-v2.vue?vue&type=script&lang=js&"
export * from "./payment-form-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports